import { Permission } from '@/enums/permission';
import { useConfig } from '@/hooks/config';
import { AuthorizableObject } from '@/types';

export function usePermissions() {
    const permissions = useConfig().permissions as Array<string> | undefined;

    function can(permission: Permission | string): boolean;
    function can(permission: Permission | string, object: AuthorizableObject): boolean;
    function can(permission: Permission | string, object?: AuthorizableObject): boolean {
        if (object !== undefined) {
            return object.authorizations?.[permission] ?? false;
        }

        return permissions?.includes(permission) ?? false;
    }

    return {
        can
    };
}
